module.exports = __webpack_public_path__ + "static/media/ic_validate.ccb2a0ff.svg";